// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "textarea[data-v-55fc24c0]{height:80px;border-radius:10px;border-width:1px;font-size:14px;border:1px solid #dfe0eb;color:#000;padding:1rem}.error[data-v-55fc24c0]{border:1px solid red}input[data-v-55fc24c0]:focus{outline:none}", ""]);
// Exports
module.exports = exports;
